export default function IconRectangle(props) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" {...props}>
      <rect x="3" y="6" width="18" height="12" rx="1"/>
    </svg>
  )
}
